import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Persistent shell — renders header, main and footer landmarks. The skip link
 * lets keyboard users jump straight to content.
 */
export default function Layout({ children }: LayoutProps) {
  return (
    <>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <div className="layout">
        <Header />
        <main id="main" className="layout__main">
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
}
